import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { BiLinkExternal } from "react-icons/bi";
import Response_Processing from "../../../../../src/layout/Others/Response_Processing";
import { useMyContext } from "../../../../components/Provider/CommonProvider";
import AdminSaveHeader from "../../../../components/CommonComponents/AdminSaveHeader";
import FormContainer from "../../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../../components/CommonComponents/MessageHeading";
import MessageSubHeading from "../../../../components/CommonComponents/MessageSubHeading";
import MessageLabel from "../../../../components/CommonComponents/MessageLabel";
import AdminSwitch from "../../../../components/CommonComponents/AdminSwitch";
import AdminCustomSelect from "../../../../components/CommonComponents/AdminCustomSelect";
import AdminCustomInput from "../../../../components/CommonComponents/AdminCustomInput";
import AdminCustomPasswordInput from "../../../../components/CommonComponents/AdminCustomPasswordInput";
import AdminCustomButton from "../../../../components/CommonComponents/AdminCustomButton";
import RightWrapper from "../../../../components/CommonComponents/RightWrapper";
import Defaultloadinggif from "../../../../layout/Others/Defaultloadinggif";
import AdminBackNavigation from "../../../../components/CommonComponents/AdminBackNavigation";
import DeviceSelector from "../../../../components/PaymentComponents/DeviceSelector";

function Razorpay(props) {

  const { fetchRequest } = useMyContext()
  const [formData, setFormData] = useState({})
  const [formDataError, setFormDataError] = useState({})
  const [loading, setLoading] = useState(true);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false);

  // Supported devices from backend helper
  const [supportedDevices, setSupportedDevices] = useState(['web', 'Android', 'iOS', 'TV']);

  const combinedRef = useRef({});

  const baseURL = process.env.REACT_APP_Baseurl
  const indexApi = `${baseURL}/admin/razorpay_payment/index`
  const storeApi = `${baseURL}/admin/razorpay_payment/store`

  const handleInput = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked ? 1 : 0,
      }));
    }
    if (type === 'text') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
    if (type === 'select-one') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      if (value == 1) {
        setFormDataError((prev) => ({
          ...prev,
          Razorpay_test_secret_key: "",
          Razorpay_test_publishable_key: ""
        }));
      }
      if (value == 0)
        setFormDataError((prev) => ({
          ...prev,
          Razorpay_live_secret_key: "",
          Razorpay_live_publishable_key: ""
        }));
    }
  };

  const handleDeviceChange = (updatedDevices) => {
    // Filter only valid devices and ensure it's an array
    const validDevices = Array.isArray(updatedDevices)
      ? updatedDevices.filter(device => supportedDevices.includes(device))
      : [];

    console.log('Razorpay Device change:', { updatedDevices, validDevices, supportedDevices });

    setFormData((prev) => ({
      ...prev,
      supported_devices: validDevices
    }));
  };

  const fetchRazorpayConfig = async () => {
    // Fetch supported devices from backend
    try {
      const deviceResponse = await fetchRequest({
        method: 'GET',
        url: `${process.env.REACT_APP_Baseurl}/admin/supported-devices`,
        params: {},
        data: {},
      });

      if (deviceResponse?.status && deviceResponse?.data) {
        setSupportedDevices(deviceResponse.data);
      }
    } catch (error) {
      console.warn('Using default supported devices:', error);
    }

    const response = await fetchRequest({
      method: 'GET',
      url: `${indexApi}`,
      params: {},
      data: {}
    }).then((response) => {
      if (response?.status) {
        toast.success(response?.message)
        const razorpayData = response?.razorpay_payment;
        let deviceArray = []; // default

        // Parse supported_devices if it exists
        if (razorpayData?.supported_devices) {
          try {
            const parsedDevices = typeof razorpayData.supported_devices === 'string'
              ? JSON.parse(razorpayData.supported_devices)
              : razorpayData.supported_devices;
            deviceArray = Array.isArray(parsedDevices) ? parsedDevices : [];
            console.log('Razorpay Loaded devices:', deviceArray);
          } catch (error) {
            console.warn('Invalid supported_devices format:', razorpayData.supported_devices);
            deviceArray = [];
          }
        }

        setFormData({
          ...razorpayData,
          supported_devices: deviceArray
        })
      }
    }).catch((err) => {
      toast.error(err?.response?.data?.message || err?.message || err?.response?.message)
    }).finally(() => {
      setLoading(false)
    })
  }
  const formValidation = () => {
    let formIsValid = true;

    // Validate supported devices
    if (!formData?.supported_devices || !Array.isArray(formData.supported_devices) || formData.supported_devices.length === 0) {
      toast.warning('Please select at least one supported device.');
      formIsValid = false;
    }
    if (formData?.payment_mode == 1) {

      if (!formData?.Razorpay_live_publishable_key) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          Razorpay_live_publishable_key: "Razorpay live publishable key cannot be empty.",
        }));
        combinedRef.current['Razorpay_live_publishable_key'].focus()
        formIsValid = false;
      }
      if (!formData?.Razorpay_live_secret_key) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          Razorpay_live_secret_key: "Razorpay live secret key cannot be empty.",
        }));
        combinedRef.current['Razorpay_live_secret_key'].focus()
        formIsValid = false;
      }
    }
    if (formData?.payment_mode == 0) {
      if (!formData?.Razorpay_test_publishable_key) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          Razorpay_test_publishable_key: "Razorpay test publishable key cannot be empty.",
        }));
        combinedRef.current['Razorpay_test_publishable_key'].focus()
        formIsValid = false;
      }
      if (!formData?.Razorpay_test_secret_key) {
        setFormDataError((prevFormData) => ({
          ...prevFormData,
          Razorpay_test_secret_key: "Razorpay test secret key cannot be empty.",
        }));
        combinedRef.current['Razorpay_test_secret_key'].focus()
        formIsValid = false;
      }
    }
    return formIsValid;
  }

  const handleStore = async () => {
    console.log('Razorpay Form data before validation:', formData);
    if (formValidation()) {
      setShowOverlay(true)
      const dataToSend = {
        ...formData,
        supported_devices: JSON.stringify(formData.supported_devices || [])
      };
      console.log('Razorpay Data being sent:', dataToSend);

      const response = await fetchRequest({
        method: 'POST',
        url: `${storeApi}`,
        params: {},
        data: dataToSend
      }).then((response) => {
        if (response?.status) {
          toast.success(response?.message)
          setWithOutRefresh(prev => !prev)
        }
      }).catch((err) => {
        toast.error(err?.response?.data?.message || err?.message || err?.response?.message)
      }).finally(() => {
        setShowOverlay(false)
      })
    }
    else {
      toast.error("Validation error: Please fill in the details.");
    }
  }

  useEffect(() => {
    fetchRazorpayConfig()
  }, [withOutRefresh])

  if (loading) {
    return <Defaultloadinggif className={"heightOnLoader"} />
  }
  return (
    <>
      {showOverlay && (<Response_Processing />)}
      <AdminBackNavigation id="playout-backbtn" path="/payment_settings" text="Back" />
      <AdminSaveHeader heading={"Razorpay Setting"} saveText={"Update Razorpay"} saveMethod={handleStore} loading={showOverlay} buttonId="topUpdateButton" />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text="Razorpay Configuration" />
            <Link to="https://razorpay.com/" target="_blank" className="d-inline-flex  align-items-center gap-2 p-2 rounded-2 shadow mb-4">
              <MessageSubHeading text="https://razorpay.com/" noMargin />
              <BiLinkExternal className="text-dark ms-2" />
            </Link>

            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-7 col-md-7 pe-2">
                <MessageLabel text={"Enable Payment Mode"} />
              </div>
              <div className="col-3 col-md-3 ps-2 text-end">
                <AdminCustomSelect id="razorPayPaymentMode" className="payment-mode-custom-select " name="payment_mode" value={formData?.payment_mode} onChange={handleInput} ref={(el) => (combinedRef.current.payment_mode = el)} options={[{ name: "TEST", value: 0 }, { name: "LIVE", value: 1 }]} error={""} defaultOptionName={""} />
              </div>
            </div>

            <MessageLabel text={"Razorpay Name"} className="" />
            <AdminCustomInput id="razorPayName" type="text" name="Razorpay_Name" value={formData?.Razorpay_Name} onChange={handleInput} placeHolder={"Razorpay Name"} ref={(el) => (combinedRef.current.Razorpay_Name = el)} error={formDataError?.Razorpay_Name} />
            <MessageLabel text={"Razorpay Label"} className="" />
            <AdminCustomInput id="razorPayLabel" type="text" name="Razorpay_label" value={formData?.Razorpay_label} onChange={handleInput} placeHolder={"Razorpay label"} ref={(el) => (combinedRef.current.Razorpay_label = el)} error={formDataError?.Razorpay_label} />
          </Wrapper>

          <Wrapper>
            <DeviceSelector
              selectedDevices={formData?.supported_devices || []}
              onDeviceChange={handleDeviceChange}
              gatewayName="razorpay"
              availableDevices={supportedDevices}
              showDescriptions={true}
              label="Supported Devices"
              showSelectAll={true}
              className=""
              cardStyle="default"
              showDeviceStats={true}
            />
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>

          <Wrapper>
            <MessageHeading text="Razorpay Key Details (TEST)" />
            {/* <MessageLabel text={"Razorpay Test Secret ID"} className="" />
            <AdminCustomInput type="text" name="Razorpay_Testkeyid" value={formData?.Razorpay_Testkeyid} onChange={handleInput} placeHolder={"Razorpay Testkeyid"} ref={(el) => (combinedRef.current.Razorpay_Testkeyid = el)} error={formDataError?.Razorpay_Testkeyid} /> */}
            <MessageLabel text={"Razorpay Test Publishable Key"} className="" />
            <AdminCustomPasswordInput id="razorPayTestPublishKey" name="Razorpay_test_publishable_key" value={formData?.Razorpay_test_publishable_key} onChange={handleInput} placeHolder={"Razorpay test publishable key"} ref={(el) => (combinedRef.current.Razorpay_test_publishable_key = el)} error={formDataError?.Razorpay_test_publishable_key} />
            <MessageLabel text={"Razorpay Test Secret Key"} className="" />
            <AdminCustomPasswordInput id="razorPayTestSecretKey" name="Razorpay_test_secret_key" value={formData?.Razorpay_test_secret_key} onChange={handleInput} placeHolder={"Razorpay test secret key"} ref={(el) => (combinedRef.current.Razorpay_test_secret_key = el)} error={formDataError?.Razorpay_test_secret_key} />
          </Wrapper>

          <Wrapper>
            <MessageHeading text="Razorpay Key Details (LIVE)" />
            {/* <MessageLabel text={"Razorpay Live Secret ID"} className="" />
            <AdminCustomInput type="text" name="Razorpay_Livekeyid" value={formData?.Razorpay_Livekeyid} onChange={handleInput} placeHolder={"Razorpay Livekeyid"} ref={(el) => (combinedRef.current.Razorpay_Livekeyid = el)} error={formDataError?.Razorpay_Livekeyid} /> */}
            <MessageLabel text={"Razorpay Live Publishable Key"} className="" />
            <AdminCustomPasswordInput id="razorPayLivePublishKey" name="Razorpay_live_publishable_key" value={formData?.Razorpay_live_publishable_key} onChange={handleInput} placeHolder={"Razorpay live publishable key"} ref={(el) => (combinedRef.current.Razorpay_live_publishable_key = el)} error={formDataError?.Razorpay_live_publishable_key} />
            <MessageLabel text={"Razorpay Live Secret Key "} className="" />
            <AdminCustomPasswordInput id="razorPayLiveSecretKey" name="Razorpay_live_secret_key" value={formData?.Razorpay_live_secret_key} onChange={handleInput} placeHolder={"Razorpay live secret key"} ref={(el) => (combinedRef.current.Razorpay_live_secret_key = el)} error={formDataError?.Razorpay_live_secret_key} />
          </Wrapper>

          <Wrapper>
            <MessageLabel text={"Razorpay Webhooks"} className="" />
            <AdminCustomInput id="razorPayWebHook" type="text" name="Razorpay_webhooks" value={formData?.Razorpay_webhooks} onChange={handleInput} placeHolder={"Razorpay webhooks"} ref={(el) => (combinedRef.current.Razorpay_webhooks = el)} error={formDataError?.Razorpay_webhooks} disabled />
            <MessageLabel text={"Razorpay Webhooks Secret Key"} className="" />
            <AdminCustomPasswordInput id="razorPayWebHookKey" name="Razorpay_webhooks_secret_key" value={formData?.Razorpay_webhooks_secret_key} onChange={handleInput} placeHolder={"Razorpay webhooks secret key"} ref={(el) => (combinedRef.current.Razorpay_webhooks_secret_key = el)} error={formDataError?.Razorpay_webhooks_secret_key} />
          </Wrapper>
        </RightWrapper>
        <AdminCustomButton id="bottomUpdateButton" className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={"Update Razorpay"} loading={showOverlay} />
      </FormContainer>
    </>
  );
}

export default Razorpay;
